import type { Project } from '@customink/project-service-react-components';

import type { GA_EVENT_NAME } from '@/constants';

type DataLayerEvent = {
  account_id?: string;
  ecommerce?: object | null;
  event?: string;
  project?: Project;
};

type EcommEvent = {
  accountId?: string;
  ecommerce: object;
  event: GA_EVENT_NAME;
  project?: Project;
};

export const googleAnalyticsEcommEvent = ({
  accountId,
  ecommerce,
  event,
  project,
}: EcommEvent) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: null,
  });

  const data: DataLayerEvent = {
    ecommerce,
    event,
    project,
  };

  if (accountId) {
    data.account_id = accountId;
  }

  window.dataLayer.push(data);
};

export type AnalyticsEvent = Record<
  string | 'event' | 'eventCategory' | 'eventAction' | 'eventLabel',
  string | number | null
>;

export const googleAnalyticsTag = (event: AnalyticsEvent) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};

export type ApplePayInteraction =
  | 'payment button click'
  | 'error empty card'
  | 'success'
  | 'cancel'
  | 'failed payment'
  | 'error address'
  | 'error merchant';

export const applePayAnalyticsEvent = (
  payment_interaction: ApplePayInteraction,
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'payment_interaction',
    payment_method: 'apple pay',
    payment_type: 'express',
    payment_interaction,
  });
};
